module.exports = __webpack_public_path__ + "static/img/bronze.3351ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bronze.png
// module id = a8Fc
// module chunks = 1